import CognitoUserEdit from './abstract/CognitoUserEdit'
import Config from '../../../Config'

class CompanyEdit extends CognitoUserEdit {
  constructor (props) {
    super(props)
    const initialState = this.getInitialState()
    this.state = initialState
    this.nameTitle = '会社名'
    this.apiUrl = Config.adminApiUrl.userManagement
    this.userRoleName = '企業'
    this.userRoleUrl = 'company'
    this.userRole = 'companyAdmin'
  }
}

export default CompanyEdit



// WEBPACK FOOTER //
// ./src/admin/pages/secure/CompanyEdit.js